import { useState, useCallback } from "react";

export default function useFocus(): [onFocus: () => void, onBlur: () => void, isFocused: boolean] {
  const [isFocused, setIsFocused] = useState(false);
  const onFocus = useCallback(() => setIsFocused(true), [setIsFocused]);
  const onBlur = useCallback(() => setIsFocused(false), [setIsFocused]);

  return [onFocus, onBlur, isFocused];
}
